import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Properties from './pages/Properties';
import PropertyDetail from './components/properties/PropertyDetail';
import Project from './pages/Project';
import ProjectDetail from './components/projects/ProjectDetail';
import Blog from './pages/Blog';
import BlogDetail from './components/bloog/BlogDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Unauthorized from './pages/Unauthorized';
import Layout from './components/layout/Layout';
import AdminLayout from './admin/adminLayout/AdminLayout';
import Dashboard from './admin/dashboard/Dashboard';
import PropertiesPage from './admin/pages/Properties';
import AddProperyForm from './admin/pages/AddProperyForm';
import AmmentiesPage from './admin/pages/AmmentiesPage';
import AgentsPage from './admin/pages/AgentsPage';
import BrnchesPage from './admin/pages/BrnchesPage';
import BlogPage from './admin/pages/BlogPage';
import Location from './admin/loctions/Location';
import BlogPostBuilder from './admin/blog/AddBlog';
import SettingsPage from './admin/pages/SettingsPage';
import AdminLogin from './admin/auth/AdminLogin';
import ProtectedRoute from './components/common/ProtectedRoute';
import AboutPage from './admin/pages/AboutPage';
import PartnersPage from './admin/pages/PartnersPage';
import ReviewsPage from './admin/pages/ReviewsPage';
import AdminUsers from './admin/security/AdminUsers';
import ChangePassword from './admin/security/ChangePassword';
import Inquiries from './admin/inquiries/Inquiries';

const App = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path="/" element={<Home />} />
      <Route path="/listing" element={<Properties />} />
      <Route path="/properties/detail" element={<PropertyDetail />} />
      <Route path="/projects" element={<Project />} />
      <Route path="/project/detail" element={<ProjectDetail />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
    </Route>

    <Route path="/admin/login" element={<AdminLogin />} />
    <Route path="/admin/unauthorized" element={<Unauthorized />} />
    <Route element={<ProtectedRoute />}>
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="properties" element={<PropertiesPage />} />
        <Route path="properties/add" element={<AddProperyForm />} />
        <Route path="amenities" element={<AmmentiesPage />} />
        <Route path="agents" element={<AgentsPage />} />
        <Route path="branches" element={<BrnchesPage />} />
        <Route path="blogs" element={<BlogPage />} />
        <Route path="location" element={<Location />} />
        <Route path="blog/add" element={<BlogPostBuilder />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="partners" element={<PartnersPage />} />
        <Route path="reviews" element={<ReviewsPage />} />
        <Route path="inquiries" element={<Inquiries />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="admin-users" element={<AdminUsers />} />
      </Route>
    </Route>



    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default App;
